import React, { useState, useEffect } from "react";
import { View, ScrollView, KeyboardAvoidingView } from "react-native";

import { hasItems } from "../../../helpers/utils";

import Header from "../common/header";
import EditSetsViewFabButton from "./EditSetsViewFabButton";
import appStyles from "../../appStyles";
import ElementsList from "../elements/list/ElementsList";
import ElementsHelper from "../elements/ElementsHelper";
import Search from "../common/search-bar/Search";
import ComparisonHelper from "../home/cards/reflection/ComparisonHelper";

const SORT_BY = "checked|is_core|is_major|name";

export default function EditElementsView({
  controller,
  selectedSetIds = [],
  goBack = () => {},
  isFromComparisonPage = false,
}) {
  const [itemsList, setItemsList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const data = ElementsHelper.filterResults(
      controller,
      {
        sortBy: SORT_BY,
      },
      selectedSetIds,
    );

    setItemsList(data);
  }, []);

  const saveSelectedElement = (selectedSet, isSelected) => {
    if (isFromComparisonPage) {
      return ComparisonHelper.markAsSelected(controller, selectedSet.id, isSelected);
    }

    save({
      action: "save",
      target: "set_view_entry",
      id: selectedSet.id,
      selected: isSelected ? 1 : 0,
      view: "Default",
    });
  };

  const save = (action) => {
    setIsLoading(true);
    console.log("Save View Entry");
    controller.cardActionWithCallback(action, () => {
      setIsLoading(false);
    });
  };

  // ------------------------------------- SEARCH -------------------------------------
  const filterResults = (filters) => {
    setIsLoading(true);
    const elements = ElementsHelper.filterResults(controller, {
      ...filters,
      sortBy: SORT_BY,
    });

    setIsLoading(false);
    setItemsList(elements);
  };

  if (!hasItems(itemsList)) return null;

  const title = isFromComparisonPage ? "Customize Comparisons" : "Edit View";
  const subTitle = isFromComparisonPage
    ? "Select Comparisons to see"
    : "Select Elements for View";

  return (
    <View style={appStyles.container}>
      <KeyboardAvoidingView style={appStyles.kbView} behavior="height">
        <Header
          title={title}
          subTitle={subTitle}
          hideAvatar
          goBack={goBack}
          controller={controller}
          isLoading={isLoading}
        />
        <ScrollView
          style={appStyles.scrollView}
          contentContainerStyle={appStyles.scrollViewContent}
        >
          <ElementsList
            showSelector
            controller={controller}
            elements={itemsList}
            onElementSelected={saveSelectedElement}
          />
        </ScrollView>

        <View style={[appStyles.footerOptions]}>
          <EditSetsViewFabButton />

          <Search
            placeholder="Search Elements"
            controller={this.controller}
            filterResults={filterResults}
          />
        </View>
      </KeyboardAvoidingView>
    </View>
  );
}
